
body.unscrollable {
  overflow: hidden;
}
.carousel  .slider {
  gap: 0;
}

.wrapper {

  *:focus {
    outline: none
  }

  // prevent selecting images
  .carousel-root {
    user-select: none;
  }

  .carousel {
    .thumbs {
      white-space: inherit;
      flex-wrap: wrap;
      justify-content: center;
      transform: none !important;
    }

    .thumb {
      display: inline-flex;
      align-items: center;
      border: 0 none;
      border-radius: var(--border-radius);
      cursor: pointer;
      background-color: #e7e7e7;
      padding: 4px;

      img {
        transition: all .15s ease-in;
      }
    }

    .thumb.selected, .thumb:hover {
      border: 0 none;
      img {
        transform: scale(1.1);
      }
    }
  }

  .carousel.carousel-slider {

    .control-prev{
      left: 20px;
    }
    .control-next{
      right: 20px;
    }
    $size: 38px;
    .control-arrow {
      top: calc(50% - ($size/2));
      height: $size;
      width: $size;
      display: flex;
      align-items: center;
      background: var(--beigedarker);
      opacity: .6;
      justify-content: center;
      border-radius: 50%;

      &.control-disabled {
        display: none;
      }

      &:hover {
        opacity: 1;
        background: var(--beigedarker);
      }
    }
  }
}
